// extracted by mini-css-extract-plugin
module.exports = {"rotate":"driftSection-module--rotate--15CvO","rotation":"driftSection-module--rotation--1fone","stable":"driftSection-module--stable--r_Ogi"};